import axios from 'axios';
import config from '../../config/config';
import { streamingDomain, uploadApiDomain } from '../../config/config-video';
import queryString from 'querystring';
import imageCompression from 'browser-image-compression';
import {
	updateVideoProgress
} from '../actions/video_upload';
import {
	updateImagesBeingUploaded,
	getListingData,
	reloadActionCardSlider
} from '../actions/products';
import { objectionalKeyHandling , getJdMartParams } from '../utills';
import { showHideLoader } from '../actions';
import { setGalleryImageUpload, setNotificationData } from '../pages/listing/Notifications/redux/action';
const MAX_MEDIA_FILE_SIZE = {
	'image': 4 * 1024 * 1024,
	'video': 100 * 1024 * 1024
}
// const MAX_CANVAS_SIZE = 1024;
const VALID_MEDIA_EXT = ['jpeg', 'png', 'jpg', 'webp', 'mp4', 'avi', 'mov', 'MOV'];
const VALID_IMAGE_EXT = ['jpeg', 'png', 'jpg', 'webp'];
const VALID_IMAGE_MIME = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
const VALID_VIDEO_MIME = ['video/mp4', 'video/x-msvideo', 'video/quicktime'];
const RANDOM_COLORS = [
	'FCF4FF',
	'FDF9F1',
	'F6F7FD',
	'EEFAF7',
	'FFEFF9',
	'EAFAFF',
	'FFF4F4'
];
const MAX_IMAGES_ALLOWED = 40;
const MAX_VIDEOS_ALLOWED = 1;

let storeGetter = null;
const getSessionStore = () => {
	if(!storeGetter){
		return {};
	}
	return storeGetter().getState().session;
}
export const setStoreGetter = getStore => storeGetter = getStore;

let curIndex = 0;
const getApiDomainForImage = () => {
	const imageApiDomain = config.apiDomains[curIndex + 1];
	curIndex = (curIndex + 1) % 2
	return imageApiDomain;
}

const imageCompressionHandler = ({ fileData }) => {
	//compress in all the scenarios to maintain exif rotation
	/* if(fileData.size <= MAX_MEDIA_FILE_SIZE['image']){
		console.log('Did not compressed', fileData.name);
		return fileData
	} */
	const sizeInMB = fileData.size / 1024 / 1024;
	let qualityIndex = 1;
	if(sizeInMB > 1 && sizeInMB <= 5) {
		qualityIndex = 0.90;
	}else if(sizeInMB > 5 && sizeInMB <= 10) {
		qualityIndex = 0.80;
	}else if(sizeInMB > 10) {
		qualityIndex = 0.50;
	}
	console.log('org file size : ',sizeInMB);
	if(sizeInMB > 1) {
		return imageCompression(fileData, {
			initialQuality: qualityIndex,
			onProgress: (prog) => {}
		})
	}else {
		return new Promise((resolve) => {
			resolve(fileData)
		})
	}
}

const isVideoFile = (fileData) => {
	const ext = getFileExtension(fileData);
	return ['mp4', 'avi',  'mov'].includes(ext.toLowerCase()) || VALID_VIDEO_MIME.includes(fileData.type);
}

const uploadFile = /* async  */({ fileData, imgIndex, updateImage, ext, productId, imgUploadUrl }) => {
	const isVideo = fileData.isVideo;
	if(isVideo){
		updateImage({
			imgIndex,
			isVideo,
			status: 'UNDER_REVIEW',
			videoName: fileData.name
		});
		uploadFileRequest({
			fileData,
			imgIndex,
			updateImage,
			isVideo,
			productId
		});
	} else{
		if(!storeGetter){
			return;
		}
		const store = store || storeGetter();
		console.time(`compression${imgIndex}`);
		imageCompressionHandler({fileData})
			.then((compressedFile) => {
				console.timeEnd(`compression${imgIndex}`);
				console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
				compressedFile = new File([compressedFile], fileData.name);
				imageCompression.getDataUrlFromFile(compressedFile)
					.then((base64Url) => {
						updateImage({
							base64Url,
							imgIndex,
							isVideo,
							compressedFile,
							updateImage,
							isVideo,
							productId,
							imgUploadUrl

						});
					})
			}).catch((err) => {
				console.log(err);
				//remove if error imgIndex from imageObj
			})
	}
};

/* const compressFileInSize = ({
	updateImage,
	uploadFileRequest,
	fileData,
	imgIndex,
	image,
	variantId
}) => {
	let oih = image.naturalHeight, //original image height
		oiw = image.naturalWidth,
		oir = 0,
		tiw = 0, //target image width
		tih = 0,
		tir = 0,
		sx = 0,
		sy = 0,
		riw = 0, //resultant image width
		rih = 0,
		priorityDim = 'height';

	oir = oih / oiw;
	tir = tiw ? tih / tiw : 0;
	//handle when tir ==0 i.e. set aspect ratio to 16:9

	if (!tir) {
		let aspectRatio = 16 / 9;
		tir = 1 / aspectRatio;
		tiw = oiw;
		tih = oiw / aspectRatio;
	}
	if (tir < oir) {
		priorityDim = 'width';
	}

	let fiw = 0, //TODO remove use riw
		fih = 0; //TODO remove use rih
	if (priorityDim == 'width') {
		fiw = oiw;
		fih = (tih * oiw) / tiw; //todo roundOff
	} else {
		fih = oih;
		fiw = (oih * tiw) / tih; //todo roundOff
	}
	riw = fiw;
	rih = fih;
	if (fiw > MAX_CANVAS_SIZE) {
		riw = MAX_CANVAS_SIZE;
		rih = (riw * fih) / fiw;
	}
	sx = (oiw - fiw) / 2;
	sy = (oih - fih) / 2;
	let canvas = document.createElement('canvas');
	canvas.width = riw;
	canvas.height = rih;
	let context = canvas.getContext('2d');
	//todo remove canvas
	context.drawImage(image, sx, sy, fiw, fih, 0, 0, riw, rih);
	let compression = 1;
	if (fileData.size < 10 * 1024 * 1024) {
		compression = 0.9;
	} else {
		compression = 0.8;
	}
	canvas.toBlob(
		blob => {
			const file = new File([blob], fileData.name);
			uploadFileRequest({
				fileData: file,
				imgIndex,
				updateImage,
				variantId
			});
		},
		'image/jpeg',
		compression
	);
}; */
const getImageResolution = (file) => {
	return new Promise((res,rej) => {
		const img = new Image();
		img.src = window.URL.createObjectURL(file);
			img.onload = function () {
				res({ completed: img.complete, width:  img.width , height: img.height });
			}
			img.onerror = function(){
				res({ error: true });
			}
	})
}

const uploadFileRequest = ({ fileData, imgIndex, updateImage, isVideo, productId, imgUploadUrl },showToastMessage,store) => {
	if(!fileData) return
	var formData = new FormData();
	const isOldAPI=imgUploadUrl?.includes("uploadProductImageForLibrary") || imgUploadUrl?.includes('uploadGenericImage.service');
	if(isVideo || isOldAPI) {
		formData.append('uploadedImageFile', fileData);
	}else {
		formData.append('file[]',fileData);
	}
	if (isVideo) {
		uploadVideoRequest(formData, imgIndex, updateImage, productId);
	} else {
		uploadImageRequest(formData, imgIndex, updateImage, productId, imgUploadUrl,showToastMessage,store);
	}
};
const updateImgYetToUpload = (obj, add = true) => {
	if(!storeGetter){
		return;
	}
	const store = store || storeGetter();
	const state = store.getState();
	let payload = state.products ? state.products.imagesBeingUploaded || [] : [];
	if(add){
		payload.push(obj);
	} else {
		payload = payload.filter((cur) => cur.imgIndex != obj.imgIndex);
	}
	store.dispatch(updateImagesBeingUploaded(
		payload
	));
}
const apisForProductImages = {}

export const prepareApiUrls = (sessionObj) => {
	const {
		source,
		supplierId
	} = sessionObj;
	if(source === 'webstore'){
		apisForProductImages.imageUpload = getApiDomainForImage() + '/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId=' + supplierId
	} else{
		apisForProductImages.imageUpload = getApiDomainForImage() + '/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId=' + supplierId
	}
}
const uploadImageRequest = (formData, imgIndex, updateImage, productId, imgUploadUrl, showToastMessage) => {
	const sessionObj = getSessionStore();
	const failUpldMsg = "Some images failed to upload. Please try again.";
	if(productId) {
		updateImgYetToUpload({
			imgIndex,
			productId
		});
	}
	var url = '';
	let supplierId = sessionObj.supplierId;
	if(!supplierId && window.Manager){
		supplierId = Manager.CurrentUser.getSupplierId();
	}
	const store = store || storeGetter();
	const state = store.getState();
	let useOfnewApi = false;
	if(supplierId){
		if(imgUploadUrl){
			url = imgUploadUrl+(imgUploadUrl.indexOf('supplierId')==-1 ? '?supplierId='+supplierId : '');
		}else{
			// url = '/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId='+supplierId;
			url = '/vendorapis/products/product/uploadImage'
			useOfnewApi = true;
		}
	}else if(imgUploadUrl && new RegExp('isEnrich').test(imgUploadUrl)){
		url = imgUploadUrl.replace('isEnrich', '');
	}else{
		url = apisForProductImages.imageUpload;
	}
	axios({
		url: url,
		method: 'POST',
		data: formData, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
		cache: false,
		headers: { 'Content-Type': 'multipart/form-data' },
		cancelToken: new CancelToken(function executor(c) {
			// An executor function receives a cancel function as a parameter
			mediaApiCancelTokens[imgIndex] = c;
		})
	})
		.then(({ data }) => {
			if(productId === 'ADD_PRODUCT'){
				if(storeGetter){
					let imagesBeingUploaded = state.products.imagesBeingUploaded || [];
					imagesBeingUploaded.forEach((cur) => {
						if(cur.imgIndex === imgIndex && cur.productId != 'ADD_PRODUCT'){
							productId = cur.productId;
						}
					})
				}
			}
			let {url} = data?.imageUrlSize ? data?.imageUrlSize[0] : {}
			let imgURL = url || data.imgURL;
			if(((useOfnewApi && data?.errors?.code != 0) || (!useOfnewApi && data?.status!='success'))  || !imgURL) {
					showToastMessage &&
				showToastMessage({
					showToastMessage: true,
					message: failUpldMsg,
					type: 'error'
				});
				store.dispatch({
					type: 'DELETE_IMAGE_FROM_ADD_EDIT',
					payload: {
						imageUrlArr: store.getState().products.editProduct.imageUrlArr.filter(cur => cur.imgIndex != imgIndex)
					}
				})
			}else {
				updateImage({
					imgURL,
					actualPath: getImagePath(imgURL),
					imgIndex,
					uploaded: true,
					productId,
					galleryId: data.id
				});
			}
			updateImgYetToUpload({
				imgIndex,
				productId
			}, false);
		})
		.catch(err => {
			console.log(err);
			showToastMessage &&
				showToastMessage({
					showToastMessage: true,
					message: failUpldMsg,
					type: 'error'
				});
			store.dispatch({
				type: 'DELETE_IMAGE_FROM_ADD_EDIT',
				payload: {
					imageUrlArr: store.getState().products.editProduct.imageUrlArr.filter(cur => cur.imgIndex != imgIndex)
				}
			})
			updateImgYetToUpload({
				imgIndex,
				productId
			}, false);
		});
}

function RegulateUpdate(delayMS = 500) {
    this.scheduleAPI = {
        timeout: null,
        last_cb_at: null,
        set callback(cbFunc) {
            clearTimeout(this.timeout)
            const scheduleCB = () => {
                this.timeout = setTimeout(() => {
                    cbFunc()
                    this.last_cb_at = new Date()
                }, delayMS)
            }
            const diff=(new Date() - this.last_cb_at)
            if (!this.last_cb_at ||  diff>= delayMS) {
                cbFunc()
                this.last_cb_at = new Date()
                return
            }
            scheduleCB()
        },
    }
}

const CancelToken = axios.CancelToken;
export const mediaApiCancelTokens = {};
const uploadVideoRequest = (formData, imgIndex, updateImage, productId) => {
	let percentCompleted = 0;
	let interval;
	updateImgYetToUpload({
		imgIndex,
		productId,
		forVideo: true
	});
	let store;
	if(storeGetter){
		store = store || storeGetter();
	}
	const uploadProgress = (progress, videoKey) => {
		progress = Math.round(progress);
		setTimeout(() => {
			store.dispatch(updateVideoProgress({
				progress,
				videoKey
			}))
		}, 100)
	}
	// const compressionProgess = (compressed) => {
	// 	if(compressed && interval){
	// 		clearInterval(interval);
	// 		uploadProgress(100, imgIndex);
	// 	}
	// 	interval = setInterval(() => {
	// 		percentCompleted++;
	// 		percentCompleted = Math.min(percentCompleted, 98);
	// 		uploadProgress(percentCompleted, imgIndex);
	// 		if(percentCompleted === 98){
	// 			clearInterval(interval);
	// 		}
	// 	}, 500);
	// }
	const rg = new RegulateUpdate(100)
	const { session } = store.getState();
	let progressSize = 0;
	axios({
		url: `${uploadApiDomain}/uploadB2BProductVideo?fileName=uploadedImageFile&token=${session.token}&env=beta`,//${config.environment}`,
		method: 'POST',
		data: formData, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
		headers: { 'Content-Type': 'multipart/form-data','Access-Control-Allow-Origin': '*' },
		onUploadProgress: function(progressEvent) {
			console.log({loaded:progressEvent.loaded,total:progressEvent.total,perc:Math.round( (progressEvent.loaded * 100) / progressEvent.total)})
			// if(!progressSize || (progressSize && progressSize != progressEvent.total)) {
				const actualProgess = Math.round( (progressEvent.loaded * 100) / progressEvent.total);
				percentCompleted = actualProgess * 0.75;
				progressSize = progressEvent.total;
				// uploadProgress(actualProgess, imgIndex);
				
				rg.scheduleAPI.callback=()=>{
					store.dispatch(updateVideoProgress({
						progress:actualProgess,
						videoKey:imgIndex,
						uploading: true,
						uploaded: false
					}))
				}
				// if(actualProgess === 100){
				// 	compressionProgess();
				// }
			// }
		},
		cancelToken: new CancelToken(function executor(c) {
			// An executor function receives a cancel function as a parameter
			mediaApiCancelTokens[imgIndex] = c;
		})
	}).then(({ data }) => {
		// compressionProgess(true);
		store.dispatch(updateVideoProgress({
			progress:100,
			videoKey:imgIndex,
			uploading: false,
			uploaded: true
		}))
		if(productId === 'ADD_PRODUCT'){
			if(storeGetter){
				const store = store || storeGetter();
				const state = store.getState();
				let imagesBeingUploaded = state.products.imagesBeingUploaded || [];
				imagesBeingUploaded.forEach((cur) => {
					if(cur.imgIndex === imgIndex && cur.productId != 'ADD_PRODUCT'){
						productId = cur.productId;
					}
				})
			}
		}
		if(storeGetter){
			const store = store || storeGetter();
			const state = store.getState();
			let listingData = {};
			if(state && state.products && state.products.tabKey){
				listingData.tabKey = state.products.tabKey;
			}
		}
		updateImage({
			imgURL: data.videoURL,
			actualPath: `${streamingDomain}${data.videoURL}`,
			thumbnailURL: data.thumbnailURL,
			originalPath: data.originalPath,
			imgIndex,
			forUpload: true,
			isVideo: true,
			productId
		})
		updateImgYetToUpload({
			imgIndex,
			productId,
			forVideo: true
		}, false);
	}).catch((err) => {
		console.log(err);
		updateImgYetToUpload({
			imgIndex,
			productId,
			forVideo: true
		}, false);
	})
}

const uploadMultipleFile = async ({
	imageUrlArr,
	data,
	forChangeImage,
	productId,
	updateImage,
	showToastMessage,
	forVideo,
	imgUploadUrl,
	onErrorCB,
	isMobile=true,
	uploadedFrom,
	imgSuccessMsg=''
}) => {
	if (!data.length) {
		return;
	}

	let finalDataArr = []; //all valid images
	let showInvalidFileQualityToast = false;
	let fileQualityErrormsg = '';
	let showMaxImagesToast = false;
	let showInvalidFileToast = false;
	let imagesPromiseArr = [];
	let tempDataArr = [];

	const dimensionToast = () => {
		if(!showInvalidFileQualityToast){
			return;
		}
		showToastMessage &&
			showToastMessage({
				showToastMessage: true,
				message: fileQualityErrormsg || 'Please Upload an Image with 200 x 200 Pixels Dimension',
				type: 'error'
			});
			onErrorCB && onErrorCB('invalidDimension');
	};
	const maxImagesToast = () => {
		return new Promise((resolve) => {
			if(!showMaxImagesToast){
				return resolve();
			}
			showToastMessage &&
				showToastMessage({
					showToastMessage: true,
					message: 'Max. 40 Images Allowed',
					onHiddenCb: resolve,
					type: 'error'
				});
			onErrorCB && onErrorCB('maxImages')
		})
	};
	const invalidFileToast = (options = {}) => {
		let { type = '' } = options;
		let errMsg = 'Only JPG, JPEG & PNG Files are Supported';
		type = type.toLocaleLowerCase();
		if (type.startsWith("video") || (uploadedFrom === 'video' && !options.errMsg && !type.includes('video'))) {
			errMsg = "Only MP4, AVI & MOV Files are Supported";
		} 
		if(options.errMsg){
			errMsg = options.errMsg;
		}
		return new Promise((resolve) => {
			if(!showInvalidFileToast){
				return resolve();
			}
			showToastMessage &&
				showToastMessage({
					showToastMessage: true,
					message: errMsg,
					onHiddenCb: resolve,
					type: 'error'
				});
			onErrorCB && onErrorCB('invalidFile')
		})
	}
	let errorType = '';
	let errorMsg = '';
	let preventFilesToBeUploaded=[]
	for (let key in data) {
		const fileData = data[key];
		if (typeof fileData === 'object') {
			const type = await getFileType(fileData);
			if (type == 'image' || type == 'video') {
				const isVideo = type == 'video';
				if(forVideo && !isVideo){
					showInvalidFileToast = true;
					errorMsg = 'Only video files are allowed to upload';			
				}
				else if(isVideo && fileData.size > MAX_MEDIA_FILE_SIZE['video']){
					showInvalidFileToast = true;
					errorMsg = 'Max video size allowed is 100 MB. Please use any freely available app to compress your video before uploading';
				}
				else if(isVideo && uploadedFrom =='image'){
					showInvalidFileToast = true;
					errorMsg = 'Only JPG, JPEG, PNG and WEBP files are supported.';
				}
				else if(type == 'image' && fileData.size > 40 * 1024 * 1024){
					showInvalidFileToast = true;
					errorMsg = 'Max image size allowed is 40 MB. Please use any freely available app to compress your image before uploading';
				}
				else if(type === 'image' && uploadedFrom === 'video'){
					showInvalidFileToast = true;
					errorMsg = 'Only MP4, AVI & MOV Files are Supported.';
				}
				else{
					fileData.isVideo = isVideo;
					if(isVideo){
						finalDataArr.push(fileData);
					} else{
						const { error: imgerror } = await getImageResolution(fileData);
						if(!imgerror){
							tempDataArr.push(fileData);
							imagesPromiseArr.push(imageCompression.drawFileInCanvas(fileData).catch((e) => console.log(e)));
						} else {
							showInvalidFileToast = true;
							errorMsg = 'Image File is Corrupted. Please Upload a Valid Photo';
						}
					}
				}
			} else {
				showInvalidFileToast = true;
				errorType = fileData.type;
			}
		}
	}

	console.trace(finalDataArr)

	const imageDataArr = await Promise.all(imagesPromiseArr);
	for(let i=0;i<imageDataArr.length;i++){
		if(!imageDataArr[i]){
			continue;
		}
		let imageData = imageDataArr[i][0];
		const imageBitSize = imageData.width * imageData.height;
		let fileData = tempDataArr[i];
		if(imageBitSize > 202500){
			finalDataArr.push(fileData);
		} else {
			showInvalidFileQualityToast = true;
			fileQualityErrormsg = 'Please Upload an Image with 620 x 620 Pixels Dimensions';
		}
	}
	if (!forChangeImage && !forVideo) {
		const remainingLimit = MAX_IMAGES_ALLOWED - imageUrlArr.length;
		if (remainingLimit && finalDataArr.length > remainingLimit) {
			finalDataArr.length = remainingLimit;
			showMaxImagesToast = true;
		}
	}
	const store = store || storeGetter();
	const totalFilesCount = finalDataArr.length;
	const breakInChunks = async (finalDataArr, chunkCount = 0) => {
		let chunk = finalDataArr.splice(0,5);
		let promiseArr = [];
		chunk.forEach(async (fileData, key) => {
			let imgIndex = +new Date() + productId + key + chunkCount * 5;
			if(forVideo && productId === 'ADD_PRODUCT'){
				imgIndex = +new Date() + key;
			}
			promiseArr.push(new Promise((resolve) => {
				uploadFile({
				fileData,
				imgIndex: imgIndex,
				ext : getFileExtension(fileData),
				productId,
				updateImage: payload => {
					updateImage({
						...payload,
						showMaxImagesToast: showMaxImagesToast,
						noOfFilesToUpload: totalFilesCount
					});
					resolve({ fileData: payload.compressedFile , ...payload });
				},
				imgUploadUrl
			});
			}))
		})
		await Promise.all(promiseArr).then((resolvedImages) => {
			resolvedImages.forEach((payload) => uploadFileRequest(payload,showToastMessage,store || storeGetter()));
			if(finalDataArr.length){
				breakInChunks(finalDataArr, chunkCount+1)
			}else {
				const store = store || storeGetter();
				store.dispatch(showHideLoader({
				showLoader: false
			}))
			}
		});

	}
	store.dispatch(showHideLoader({
		showLoader: true
	}))
	invalidFileToast({type: errorType, errMsg: errorMsg })
		.then(isMobile && maxImagesToast)
		.then(dimensionToast)
		breakInChunks(finalDataArr);
};

const getMimetype = (signature) => {
	if(signature.startsWith('FFD8FF')) return 'image/jpeg';
	switch (signature) {
		case '89504E47':
			return 'image/png'
		case '47494638':
			return 'image/gif'
		case '25504446':
			return 'application/pdf'
		case '504B0304':
			return 'application/zip'
		case '00018':
			return 'video/mp4';
		default:
			return 'Unknown filetype'
	}
}

const getTypeUsingMagicNumbers = fileData => {
	const filereader = new FileReader();

	return new Promise(resolve => {
		filereader.onloadend = function(evt) {
			// evt.src='' to fix multiple images upload issue - https://tga.justdial.com/project/tejash-unified-product-bank-categorization/issue/5791
			evt.src = '';
			if (evt.target.readyState !== FileReader.DONE) {
				return;
			}

			const uint = new Uint8Array(evt.target.result);
			let bytes = [];
			uint.forEach((byte) => {
				bytes.push(byte.toString(16))
			})
			const hex = bytes.join('').toUpperCase()

			resolve(getMimetype(hex));
		}

		const blob = fileData.slice(0, 4);
		filereader.readAsArrayBuffer(blob);
	});
}

const getFileType = async fileData => {
	const sessionObj = getSessionStore();
	const isVideoEnabled = sessionObj.isVideoEnabled;
	let type = fileData.type;
	if(!type) {
		type = await getTypeUsingMagicNumbers(fileData, type => console.log(type));
	}
	if(isVideoEnabled && (VALID_VIDEO_MIME.includes(type) || type.includes('video'))){
		return 'video';
	}
	return VALID_IMAGE_MIME.includes(type) ? 'image' : '';
};

const getFileExtension = fileData => fileData.name.split('.').pop();

export const getRandomColorObj = () => {
	const randomNum = Math.floor(Math.random() * (7 - 0)) + 0;
	const color = '#' + RANDOM_COLORS[randomNum];
	return {
		backgroundColor: color
	};
};

export const updateImageApiTokens = {};

export const updateProductMediaService = async ({
	productId,
	imageUrl,
	videoUrl,
	token,
	source,
	fromListing
}) => {
	if(productId == 'ADD_PRODUCT' || !productId || !imageUrl || objectionalKeyHandling({ key: 'CHECK', value: productId})){
		return;
	}
	let url='';
	const { getStore } = await import('../../store/createStore');
  	const state = getStore().getState();
	const dispatch = getStore().dispatch;  
	if(source == "webstore") {
		url = config.apiDomains[0] +
		`/marketplace/static/php/web/b2bWebsite.php?&action=addOrUpdateImage&newListing=true&productId=` +
		productId ;
	} else {
		token = token || getSessionStore().token;
		url = config.apiDomains[0] +
		`/marketplace/static/php/web/b2bWebsite.php?&action=addOrUpdateImage&productId=` +
		productId +
		'&token=' +
		token;
		let jdMartParams = getJdMartParams();
		url += `&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`;
		if(updateImageApiTokens[productId]){
			updateImageApiTokens[productId]('New Request for Same Variant')
		}
		if(source === 'b2b'){
			url += '&imgWait=true';
		}
		if (state && state.products?.actionCardFilter && state.products?.actionCardFilter?.type=='imgMissingCoun') {
			url += '&smartCardSource=ADD_IMAGE'
		}
	}

	await axios({
		url: url,
		method: 'POST',
		data: queryString.stringify({
			imageUrl: imageUrl,
			videoUrl: videoUrl
		}),
		cancelToken: new CancelToken(function executor(c) {
			// An executor function receives a cancel function as a parameter
			updateImageApiTokens[productId] = c;
		})
	}).then(data => {
		console.log(data);
		const isProdFromListing = state?.notifications?.isProdFromListing || false
		if(isProdFromListing){
            dispatch(setGalleryImageUpload(true))
		}
		if(source == 'b2b'){
			let listingData = {};
			if(state && state.products && state.products.tabKey){
				listingData.tabKey = state.products.tabKey;
			}
		}
		if (state.products.isActionCardSliderOpen) {			
			dispatch(reloadActionCardSlider({isReloadCardSlider:true}))
			dispatch(setNotificationData({ token: token }));
			dispatch(getListingData({isFilter: true,filterStr: state.products.actionCardData.filterQuery}))
		} else {
			dispatch(getListingData({filterObj: state?.products?.filterProductObj,...listingData}));
		}
	}).catch((e) => {
		console.log(e)
	})
};

export const onFileSelUpload = (event, props, updateDefaultIndex) => {
	let initialReq = true;
	let source = getSessionStore().source;
	uploadMultipleFile({
		data: event.target.files,
		productId: props.productId,
		uploadedFrom : props.type,
		updateImage: payload => {
			//forVideo add forVideo Flag
			let editProductId = props.productId;
			if(editProductId === 'ADD_PRODUCT' && payload.productId){
				editProductId = payload.productId;
			}
			props.updateProductMedia({
				imageUrl: payload,
				editProductId,
				imgIndex: payload.imgIndex,
				forVideo: props.forVideo,
				updateDefaultIndex,
				initialReq,
				noOfFilesToUpload: payload.noOfFilesToUpload,
				showMaxImagesToast: payload.showMaxImagesToast,
				source
			});
			initialReq = false;
		},
		forVideo: props.forVideo,
		imageUrlArr: props.imageUrlArr,
		showToastMessage: props.showToastMessage,
		forChangeImage: props.forChangeImage,
		imgUploadUrl: props.imgUploadUrl
	});
};

export const getAddImageDivCount = ({
	images,
	videos,
	isSourceB2B,
	isAddEditPage
}) => {
	let count = 1;
	if(!isSourceB2B || (isAddEditPage && images == 0)){
		return count;
	}
	if(!images && videos){
		count = 2
	}
	return images === 40 ? 0 : count;
	// return isSourceB2B ? Math.max(1, 2 - imageUrlArrLength + 1) : 1;
}

const S3_REGEX = /^\/bp\//

const checkAndReplaceForS3Domain = (url) => {
	if(!S3_REGEX.test(url)){
		return ""
	}
	return url.replace(S3_REGEX, config.IMAGE_S3_DOMAIN);
}


export const getImagePath = function(url,isTemplate,type,forCropper = false) {
	if (!url || url.indexOf('http') == 0 || url.indexOf('base64') != -1) {
		if(typeof url === "string" && forCropper) {
			return '/vendor/manage-products/common-wrapper/CORS?url='+url;
		}
		return url;
	}
	let finalImagePath = "";
	finalImagePath = checkAndReplaceForS3Domain(url);
	if(finalImagePath){
		return finalImagePath;
	}

	let imageDomain = '';
	const imageDomainArray = config.staticImageDomains;
	let productImageBasePath =
		config.IMAGE_COMPRESSION + config.PRODUCT_IMAGE_BASE_PATH;
	let psvImageBasePath = config.PSV_IMAGE_BASE_PATH;
	var reg = new RegExp(/(^\/?(quickquotes|v2\/comp|comp\/def_content|rep|comp))/);
	var quickQuotes = reg.test(url);
	if(quickQuotes || isTemplate) {
		productImageBasePath = url[0] === '/' ? '' : '/';
		imageDomain = imageDomainArray[3];
	} else {
		imageDomain = imageDomainArray[0];
	}
	let imageBasePath = type == 'psv' ? psvImageBasePath : productImageBasePath
	finalImagePath = imageDomain + imageBasePath + url;
	if(forCropper) {
		return '/vendor/manage-products/common-wrapper/CORS?url='+finalImagePath;
	}
	return finalImagePath;
};

export const restoreProductDataReq = async ({type, productId, imageUrlArr, token, source}) => {
	if(type === 'image'){
		const finalImageUrl = [];
		imageUrlArr.map((imgObj) => {
			if (imgObj.uploaded) {
				finalImageUrl.push(imgObj.imgURL);
			}
		})
		setTimeout(() => {
			updateProductMediaService({
				token,
				source,
				type,
				productId,
				imageUrl: finalImageUrl.join(',')
			})
		}, 100)
	}
}

export const brochureFileValidate = async (files = []) => {
	const { getStore } = await import('../../store/createStore');
	const {
		addErrorFilesToBrochure
	} = await import('../actions/products');
	const result = [];
	const dispatch = getStore().dispatch;
	let ImageFileError = '';
	for(let i=0; i<files.length; i+=1) {
		let Imgwidth; let Imgheight; let imgComplete; let imageError;
		const ext = files[i].name.substring(files[i].name.lastIndexOf('.') + 1).toLowerCase();
		let fileType = files[i].type;
		if(!fileType) {
			fileType = await getTypeUsingMagicNumbers(files[i]);
		}
		const isImage = VALID_IMAGE_MIME.includes(fileType);
		if(isImage){
			const { width , height , completed , error } = await getImageResolution(files[i]);
			Imgheight = height;
			Imgwidth = width;
			imgComplete = completed;
			imageError = error;
		}
		const uploadHistoryFile = {
			fileName: files[i].name.split('.')[0],
			ext: files[i].name.substring(files[i].name.lastIndexOf('.') + 1).toLowerCase(),
			erroMsg: ''
		}
		if(!['png', 'jpg', 'jpeg', 'pdf', 'webp'].includes(ext) && !isImage) {
			uploadHistoryFile.erroMsg = ImageFileError = 'Only JPG, JPEG, PNG, WEBP & PDF Files Formats Supported';
			dispatch(addErrorFilesToBrochure(uploadHistoryFile))
		} else if(imageError){
			uploadHistoryFile.erroMsg = ImageFileError = 'Corrupted Image File';
			dispatch(addErrorFilesToBrochure(uploadHistoryFile))
		} else if(!isImage && files[i].type !== 'application/pdf'){
			uploadHistoryFile.erroMsg = ImageFileError = 'Only JPG, JPEG, PNG, WEBP & PDF Files Supported';
			dispatch(addErrorFilesToBrochure(uploadHistoryFile))
		} else if(Math.round(files[i].size / 1024 / 1024) > 25) {
			uploadHistoryFile.erroMsg = ImageFileError = 'Max file size allowed is 25 MB';
			dispatch(addErrorFilesToBrochure(uploadHistoryFile))
		} else if(isImage && Imgwidth * Imgheight < 176400) {
			uploadHistoryFile.erroMsg = ImageFileError = 'Image Resolution Cannot be Less than 620 px * 620 px';
			dispatch(addErrorFilesToBrochure(uploadHistoryFile))
		} else {
			result.push(files[i]);
		}
	}
	if(ImageFileError){
		return { isError: true, message: ImageFileError , data: result };
	}
	return { data: result };
}


export const uploadBrochure = async (file) => {
	const { getStore } = await import('../../store/createStore');
	const {
		addSuccessFilesToBrochure,
		addErrorFilesToBrochure
	 } = await import('../actions/products');
	const store = getStore().getState();
	const dispatch = getStore().dispatch;
	const dataToSend = new FormData();
	const uploadHistoryFile = {
		fileName: file.name.split('.')[0],
		ext: file.name.substring(file.name.lastIndexOf('.') + 1),
		extension: file.name.substring(file.name.lastIndexOf('.') + 1),
	}
	try {
		const mimeTypeToExt = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp' };
		const mimeMap = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp' };
		const fileExt = file.name.includes('.') ? file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() : '';
		let effectiveType = file.type || mimeMap[fileExt] || '';
		if(!effectiveType) {
			const detected = await getTypeUsingMagicNumbers(file);
			if(VALID_IMAGE_MIME.includes(detected)) effectiveType = detected;
		}
		const hasExt = file.name.includes('.');
		const fixedName = hasExt ? file.name : file.name + '.' + (mimeTypeToExt[effectiveType] || 'jpg');
		let fileToSend = (!file.type && effectiveType)
			? new File([file], fixedName, { type: effectiveType })
			: file;
		const isImage = effectiveType.includes('image');
		if(isImage){
			const compressedFile = await imageCompressionHandler({ fileData: fileToSend });
			fileToSend = compressedFile;
		}
		const { docId , city, user : { loggedUser : { userType, userName, subType } }, brochureButton='brochure'} = store.session;

		const isContractor = subType && (["CONTRACTOR", "CONTRACTORV2"].indexOf(subType) !== -1)

		dataToSend.append('docid', docId);
		dataToSend.append('imgname', fixedName);
		dataToSend.append('city', encodeURIComponent(city));
		dataToSend.append('owner', userType === "OWNER" ? 1: 0);
		dataToSend.append('brochure', fileToSend, fixedName);
		dataToSend.append('iscontractor', (isContractor?1:0));
		dataToSend.append('brtype', encodeURIComponent(brochureButton));
		
		const { data } = await axios.post('/marketplace/dc-brochures/uploadFiles.ns?usertype='+userType+'&docid='+docId, dataToSend, {
			headers: {
				'mobileNo': userName
			}
		});
		if(!data.error){
			uploadHistoryFile.uploaded = true;
			uploadHistoryFile.url = data.menuUrl;
			uploadHistoryFile.status = data.approved == 0 ? 'Audit Pending' : null;
			uploadHistoryFile.id = data.id;
			dispatch(addSuccessFilesToBrochure(uploadHistoryFile));
			return { url: data.menuUrl || data.main_url, ext: uploadHistoryFile.ext, fileName: uploadHistoryFile.fileName,id: data.id };
		} else {
			uploadHistoryFile.erroMsg = data.msg;
			dispatch(addErrorFilesToBrochure(uploadHistoryFile));
		}
		
	} catch (error) {
		if(!error.response || error.response.status === 500){
			uploadHistoryFile.erroMsg = 'Server Error Please upload Again!';
		} else if(error.response.status === 413){
			uploadHistoryFile.erroMsg = 'Server file limit exceed!';
		} else{
			uploadHistoryFile.erroMsg = 'Server Error Please upload Again';
		}
		dispatch(addErrorFilesToBrochure(uploadHistoryFile));
	}
}

export { uploadFile, uploadMultipleFile };
